var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.442 10.628H8.453c-1.868 0-4.37 1.913-5.42 2.9L3 2h15.79c1.547.407 5.015 1.644 6.512 3.337 1.872 2.116 2.93 3.907 2.93 8.221 0 3.451-2.387 7.136-3.58 8.547L28.231 30H6.42c-1.14-.923-3.013-3.793-1.385-7.895 1.628-4.103 5.616-5.4 7.407-5.535v2.36l8.14-5.372-8.14-4.965v2.035z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfr);
export default __webpack_public_path__ + "static/media/RFR.5acb16c8a8a53ad35079030a78bbe199.svg";
export { ForwardRef as ReactComponent };